"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _List = require("./List.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getItems = function getItems(data, isOrdered) {
  var items = data.map(function (item, index) {
    var listType = isOrdered ? 'ordered' : 'unordered';
    var key = "max-".concat(listType, "-list__item--").concat(index);
    return /*#__PURE__*/_react.default.createElement(_List.Li, {
      key: Math.floor(Math.random() * Date.now() + 100000),
      "data-key": key
    }, item);
  });
  return items;
};
var List = function List(_ref) {
  var data = _ref.data,
    ordered = _ref.ordered,
    cols = _ref.cols,
    collapse = _ref.collapse;
  return ordered ? /*#__PURE__*/_react.default.createElement(_List.OrderedList, {
    cols: cols,
    collapse: collapse,
    "data-key": "max-ordered-list"
  }, getItems(data, true)) : /*#__PURE__*/_react.default.createElement(_List.UnorderedList, {
    cols: cols,
    collapse: collapse,
    "data-key": "max-unordered-list"
  }, getItems(data));
};
List.defaultProps = {
  ordered: false,
  cols: 1,
  collapse: false
};
var _default = List;
exports.default = _default;